/* eslint-disable import/no-anonymous-default-export */
export default {
  autocomplete: {
    start_typing: 'Start typing...',
    individual_text: 'Type a city, state or country',
    lev_text: 'Type a city, state or country',
    no_options: 'No options',
  },
  featureNotInPlan: 'This feature is not available in your plan.',
  acknowledgement: "I acknowledge and agree to Valital's",
  agreement: 'I agree to',
  announcement: {
    '2fa': {
      title: 'Keep your account secure with <br /> Two-Factor Authentication',
      description: `Two-Factor Authentication allows you to connect a trusted phone number to your Valital account, 
      and use it to confirm your identity when signing in.`,
      note: 'Your organisation requires to activate Two-Factor Authentication',
      action_main: 'Enable Two-Factor Authentication',
      action_secondary: 'No thank you',
    },
  },
  lev_not_in_plan: {
    title: 'Feature not available',
    description_1: 'This feature is not available in your plan.',
    description_2: 'Please contact Valital to activate it.',
  },
  change_plan_costs_note:
    '<small>Note: you will be charged a total of <strong>{{costs}}</strong> for exhauting your current plan too soon.</small>',
  change_plan_invoice_will_be_sent:
    'An invoice will be sent in the next 24 hours.',
  back_to_home: 'Back to Home',
  continue: 'Continue',
  loading: 'Loading...',
  go_to: 'Go to',
  back: 'Back',
  verify: 'Verify',
  verifying: 'Verifying...',
  sending: 'Sending...',
  send_code: 'Send Code',
  switching: 'Switching...',
  removing: 'Removing...',
  free_trial: "You're on the free trial: {{remaining}} days remaining.",
  plan_expired: 'Your plan is expired.',
  mark_all_as_read: 'Mark All as Read',
  last_validated_on: 'Last update on {{date}}',
  notify_when_done: 'Notified by email when report is completed.',
  live_update_description:
    'LiveUpdate will monitor online media daily and will notify you of new information.',
  include_twitter_description:
    'Enable Twitter to see potential usernames and flagged tweets associated to this individual.',
  extend_report_description:
    'Enable this feature to include misconduct results that fall below our ID matching threshold. Expect more false positives as a result.',
  not_yet_validated: 'Not yet validated',
  new_version_available: "There's a new version available",
  update_now: 'Update now',
  detail_view: 'Detail View',
  grid_view: 'Grid View',
  on_date: 'on {{date}}',
  search_placeholder: 'Search by name',
  search_show_all: 'Show all results for {{value}}',
  something_went_wrong: 'Oops, something went wrong! Please try again later...',
  team_validations_depleted:
    'All validations allocated to your team have been used. Please update your allocated validations in the User Management tab to submit your validations.',
  organization_submit_succes: 'Your validation for {{name}} has been submitted',
  thank_you_for_your_input: 'Thank you for your input!',
  view_all: 'View all →',
  view_all_with_count: 'View all ({{count}}) →',
  notifications: {
    a_referral: 'a referral',
    creator_added_subject: '{{creator_name}} added {{subject_name}}',
    creator_changed_status:
      "{{creator_name}} changed {{subject_name}}'s status",
    from_to: 'from "{{previous}}" to "{{next}}"',
    has_been_validated: 'has been validated',
    has_been_declined: 'has been declined',
    in_subject_behaviour: "in {{subject_name}}'s behaviour",
    on_date: ' on {{date}}.',
    one_of: 'One of',
    significant_change_noted: 'significant change noted',
    subject_added: '{{subject_name}} added',
    subject_changed_status: '{{subject_name}} changed their invitation status',
    subject_deleted: '{{subject_name}} deleted',
    subject_referrals: "{{subject_name}}'s referrals",
    subject_removed: '{{subject_name}} removed',
    subject_updated: '{{subject_name}} updated',
    their_account: 'their account',
    to_the_company: "to the company's list of {{user_type}}s",
    human_curator_updated_report: 'The report of {{subject_name}} is available',
    refused: 'Declined',
    accepted: 'Accepted',
    pending: 'Pending',
    load_more: 'Load More',
    active: 'Active',
    inactive: 'Inactive',
  },
  pages: {
    activate: {
      almost_there: "you're almost there",
      finish_registering: 'Finish registering and start using Valital',
      stand_out: 'Make your company stand out by adding a logo (optional)',
      complete_registration: 'Complete registration',
    },
    register: {
      welcome: 'Welcome to Valital, {{firstName}}!',
      welcome_invited: 'Welcome to {{companyName}}, {{firstName}}!',
      complete_registration: 'Complete your registration',
      set_password_to_continue: 'Set your password to access your account',
      company_info: 'Company Information',
      account_name: 'Account Name',
      logo: 'Logo',
      logo_recommended_size: 'Recommended size: 512x512px (PNG or JPG)',
      upload_logo: 'Upload company logo (optional)',
      choose_file: 'Choose File',
      no_file_chosen: 'No file chosen',
      email: 'Email',
      password: 'Password',
      confirm_password: 'Confirm Password',
      password_placeholder: 'Create a strong password',
      confirm_password_placeholder: 'Re-enter your password',
      or: 'OR',
      continue_with_google: 'Continue with Google',
      continue_with_microsoft: 'Continue with Microsoft',
      microsoft_invite_dialog_title: 'Microsoft invitation required',
      microsoft_invite_dialog_body:
        'Your email must be added to your organization in Microsoft Azure before you can sign in with Microsoft. Open the invitation link, sign in with your Microsoft account, and accept the invitation.',
      microsoft_invite_open_link: 'Open Microsoft invitation',
      microsoft_invite_after_accept:
        'When you have finished accepting the invitation in Microsoft, confirm below to continue to Valital sign-in.',
      microsoft_invite_confirm_continue: 'I have accepted — continue to Microsoft sign-in',
      microsoft_invite_cancel: 'Not now',
      microsoft_prepare_unclear:
        'We could not verify the next step. Complete the Microsoft invitation if you have not, then try again.',
      microsoft_prepare_error: 'Could not verify Microsoft setup. Please try again.',
      enable_mfa: 'Enable Two-Factor Authentication (2FA)',
      enable_mfa_recommended: 'Enable Two-Factor Authentication (Recommended)',
      mfa_setup_on_login: 'Two-factor authentication will be set up when you first log in.',
      sso_info: 'Your company uses Single Sign-On (SSO). You will be able to sign in using your company credentials after completing registration.',
      sso_complete: 'Click "Complete Registration" below. You will be able to sign in using SSO on the login page.',
      login_via_sso: 'Your company uses Single Sign-On (SSO). Please log in using your SSO credentials.',
      sso_google_invited: 'Your company uses Google Single Sign-On (SSO).',
      sso_microsoft_invited: 'Your company uses Microsoft Single Sign-On (SSO).',
      signed_in_as: 'Signed in as',
      sso_email_mismatch: 'This account does not match your invitation',
      sso_email_mismatch_help: 'Complete registration below using a password for your invited email, or sign out of this account and sign in with the correct one.',
      use_different_account: 'Use different account',
      use_different_method: 'Use different method',
      company_uses_email_password: 'Your company uses email and password.',
      email_password: 'Email and password',
      sso_invited: 'Your company uses Single Sign-On (SSO).',
      sso_login_instructions: 'To access your account, please go to the login page and sign in using your company SSO credentials.',
      go_to_login: 'Go to Login Page',
      invalid_email_for_sso: 'This email did not match the selected email.',
      invalid_email_for_microsoft: 'This email did not match the selected email.',
      sso_microsoft_email_mismatch: 'The emails did not match. You are signed in to Microsoft with a different email. Please log out from Microsoft and sign in with the correct account to complete registration.',
      sso_error_sign_in_required: 'Please sign in with your Google or Microsoft account to continue.',
      sso_click_google_first: "Please sign in with Google first by clicking the 'Continue with Google' button.",
      sso_click_microsoft_first: "Please sign in with Microsoft first by clicking the 'Continue with Microsoft' button.",
      sso_error_sign_in_invalid: 'Your sign-in could not be verified. Please sign in again with the correct account.',
      sso_error_email_mismatch: 'The account you signed in with doesn\'t match the email for this registration. Please sign in with the correct account.',
      sso_error_provider_mismatch: 'Please use the same sign-in option (Google or Microsoft) that was used for your invitation.',
      registration_error_generic: 'An error occurred while completing registration.',
      accept_and_continue: 'Accept Terms and Continue',
      agree_terms: "I agree to Valital's",
      terms_of_use: 'Terms of Use',
      registration_complete: 'Registration completed successfully! Please log in.',
      registration_error: 'Registration Error',
      registration_already_complete_title: 'Your account is already active',
      registration_already_complete_body:
        'This registration link has already been used. Sign in to continue.',
      activation_link_expired: 'Activation link expired',
      request_new_activation_link: 'Request a new one to activate your account.',
      activation_link_resent: 'A new activation link has been sent to {{email}} and will expire in 48 hours.',
      back_to_login: 'Back to Login',
      resend_email: 'Resend Email',
      intro: {
        title: 'Get started for<1> free </1>in 2 simple steps.',
        free_trial: 'No credit card required',
        card_1: 'Tell us about your company',
        card_2: 'Introduce yourself',
      },
      title_step_1: 'Tell us about your company',
      input_label_step1_1: 'Company name',
      input_label_step1_2: 'Number of employees',
      title_step_2: "Now, let's get to know you",
      input_label_step2_1: 'Business email',
      sign_up: 'Sign up',
      success: {
        title: 'Your request has been submitted',
        next: 'Next: Check your email',
      },
    },
    billing: {
      add_a_card: 'Add a card',
      back_to_plans: 'Back to plans',
      send_invoices_to: 'We will send invoices to this email',
    },
    business_plans_modal: {
      plans_for_every_org:
        'Whether you’re a small or big business, we have a plan for you.',
    },
    import_csv_form: {
      title: 'Import Individuals',
      description: 'Upload a CSV file to easily add multiple individuals',
    },
    dashboard: {
      delete_talent: 'Delete talent',
      empty_dashboard: {
        title: 'Welcome to Valital!',
        subtitle:
          'Invite your first candidate or employee and receive their online conduct report and references a few minutes after they accept the invite',
        button_text: 'Invite your first talent',
      },
      cancel: {
        title: 'Cancel invitation?',
        body: 'By cancelling the request, {{first_name}} {{last_name}} will be deleted from your company.',
      },
      delete: {
        title: 'Delete {{first_name}}?',
        body: 'Are you sure you want to delete {{first_name}} {{last_name}} from your company?',
      },
      live_validation_not_available: {
        title: "Your plan doesn't support LiveUpdate alerts",
        description:
          'This feature is only available for business plans. Upgrade your plan to get access to the feature!',
      },
      pending_for_more_than_5_days: 'Pending for more than 5 days',
      columns_to_display: 'Columns to display',
    },
    delegates: {
      title: 'Your delegates',
      deactivate: {
        title: 'Deactivate {{first_name}} {{last_name}}?',
        body: 'Deactivating a user will prevent them from having delegate access to this company.',
      },
      select_user_type: 'Select a permission',
    },
    export_to_csv: 'Export to csv',
    download: 'Download',
    login: {
      '2fa': {
        title: 'Enter the security code to continue',
        new_device:
          'This appears to be a new device, browser or location. Enter the security code you received from a text message or from your authenticator app.',
        remember_me: 'Remember this device for {{ days }} days ',
        issues: 'Having issues? Try another way',
        issues_details: 'Contact us',
      },
      title: 'Welcome to Valital',
      forgot_password: 'Forgot your password?',
      start_free_plan: 'Start for free',
      invalid_code: 'Invalid code. Please try again.',
      account_no_access: 'Account does not have access',
      sign_in_with_email_password: 'Please sign in with your email and password.',
      account_not_found: 'Invalid email or password. Please try again.',
      invalid_email_or_password: 'Invalid email or password. Please try again.',
      sign_in_failed: 'Sorry, we\'re having trouble logging you in. Please verify your credentials or contact support@valital.com',
      organization_not_found: 'We could not find an account matching your credentials. Please verify your email address and authentication method.',
      email_not_found: 'The email address you entered is not found for a default login. Make sure you are typing it correctly, or you are using the correct authentication method.',
      sso_authentication_required: 'We could not find an account matching your credentials. Please verify your email address and authentication method.',
      attemps_excceeded:
        'Password attempts exceeded. Please try again in 2 minutes.',
      temporary_password_expired: 'Your temporary password has expired. ',
      temp_pass_click_here: 'Click here',
      temp_pass_reset: ' to reset it.',
      temp_pass_sent: 'Your temporary password has been sent.',
      mfa_code_resent: 'A new code has been sent.',
      send_magic_link: 'Send me a magic link',
      sending_magic_link: 'Sending...',
      magic_link_sent: 'A magic link has been sent to your email.',
      magic_link_error: 'Failed to send magic link. Please try again.',
      magic_link_email_required: 'Please enter your email address first',
      magic_link_email_invalid: 'Please enter a valid email address',
    },
    verify: {
      title: 'Verify this Email',
    },
    magic_link: {
      verifying: 'Verifying your magic link...',
      title: 'Magic Link Verification',
      invalid_token: 'Invalid magic link. No token provided.',
      invalid_or_expired: 'This link is invalid or has expired',
      expired: 'This magic link has expired.',
      request_new: 'Request a new magic link',
      request_new_link: 'Request a new link',
      return_to_login: 'Return to log in',
      back_to_login: 'Back to Login',
    },
    mfa_setup: {
      title: 'Set Up Two-Factor Authentication',
      description: 'Your company requires two-factor authentication. Choose your preferred method:',
      method_totp: 'Authenticator App',
      method_totp_description: 'Use an authenticator app like Google Authenticator, Microsoft Authenticator or Authy.',
      method_sms: 'SMS (Text message)',
      method_sms_description: 'Requires a phone number.',
      complete: 'Two-Factor Authentication Set Up Successfully!',
      complete_description: 'Your account is now protected with two-factor authentication.',
      totp_title: 'Set Up 2FA with an Authenticator App',
      totp_verify_title: 'Enter Verification Code',
      totp_description: 'Scan the QR code in your Authenticator App (Google Authenticator, Microsoft Authenticator, Authy, etc.)',
      totp_scan_instruction: 'Scan the QR code in your Authenticator App (Google Authenticator, Microsoft Authenticator, Authy, etc.)',
      totp_logo_note: '',
      totp_enter_code: 'Enter the 6-digit code from your Authenticator app',
      totp_success: 'TOTP verified successfully!',
      totp_setup_error: 'Failed to set up TOTP',
      totp_verify_error: 'Invalid verification code. Please try again.',
      totp_switch_title: 'Switch to Authenticator App',
      totp_switch_description: 'Please verify your authenticator app code to switch to this method',
      sms_title: 'Set Up 2FA with SMS',
      sms_description: 'Enter your phone number to receive verification code via text message',
      sms_enter_phone: 'Enter your phone number',
      sms_enter_code: 'Enter the 6-digit code sent to your phone',
      sms_success: 'SMS verified successfully!',
      sms_setup_error: 'Failed to send verification code',
      sms_verify_error: 'Invalid verification code',
      sms_switch_title: 'Set up SMS',
      sms_switch_description: 'A verification code has been sent to your phone. Please verify to switch to SMS authentication.',
      phone_required: 'Phone number is required',
      invalid_code: 'Please enter a 6-digit code',
      error_fetching_status: 'Error checking two-factor authentication status',
      choose_method_title: 'Two-Factor Authentication',
      choose_method_description: 'Select how you want to receive verification codes. You can set up both methods later for added security.',
      use_sms_instead: 'Use SMS instead',
      use_totp_instead: 'Use Authenticator App instead',
      disable_company_mfa_description: 'As an admin or owner, you can disable two-factor authentication for your company instead.',
      disable_company_mfa_button: 'Disable Company Two-Factor Authentication',
      mfa_required_message: '',
    },
    profile: {
      '2fa': {
        subtitle:
          'Keep your account extra secure with two-factor authentication',
        subtitle_admin:
          "Keep your organization's account extra secure with two-factor authentication",
        description: 'Two-factor authentication adds an extra layer of security by requiring a verification code in addition to your password when signing in.',
        benefit_1: 'Protects against unauthorized access',
        benefit_2: 'Works with authenticator apps like Google Authenticator',
        benefit_3: 'Can use SMS as a backup option',
        enabled: 'Enabled with phone number {{ phone_number }}',
        insert_code: 'Insert the code we sent you by SMS',
        sending_code: 'Sending verification code... This may take a few moments.',
        code_expired: 'The verification code has expired. Please request a new code.',
        invalid_code: 'Invalid code. Please try again.',
        request_new_code: 'Request New Code',
        change_number: 'Change number',
      },
      mfa_company_enable_confirm:
        'Enabling Two-Factor Authentication will require all users in your organisation to use Two-Factor Authentication. Are you sure you want to continue?',
      mfa_company_disable_confirm:
        'Disabling Two-Factor Authentication will turn it off for all users in your organisation. Are you sure you want to continue?',
      enable_mfa_warning_title: 'Enable Two-Factor Authentication',
      enable_mfa_warning_message:
        'Enabling Two-Factor Authentication (2FA) will require all users in your company to enable 2FA at their next log in.',
      enable_mfa_warning_alert: '',
      authentication_mode_updated:
        'Authentication mode updated successfully. Users will be migrated automatically.',
      updating_authentication_mode:
        'Updating authentication mode and migrating users...',
      authentication_mode_description:
        'The authentication method automatically applies to all users of the account.',
      security_settings_subtitle:
        'Manage authentication and password settings for your account',
      authentication_mode_change_confirm:
        'Changing the authentication method will apply to all users of the account. This process may take a few moments. You will be automatically logged out after the change is complete.',
      authentication_mode_logout_warning:
        'You will be automatically logged out after changing the authentication method. Please sign in again with the new authentication method.',
      authentication_mode_owner_stays_signed_in:
        'Changing the authentication method will apply to all users of the account. You will stay signed in; other users will receive an email to sign in with the new method.',
      authentication_mode_owner_stays_signed_in_point_apply:
        'Changing the authentication method will apply to all users of the account.',
      authentication_mode_owner_stays_signed_in_point_email:
        'You will stay signed in and other users will receive an email to sign in with the new method.',
      auth_mode_sso_handshake_prompt: 'Verify your email.',
      auth_mode_sso_email_verified: 'Email verified.',
      auth_mode_sso_updating: 'Updating...',
      auth_mode_sso_apply: 'Apply',
      auth_mode_sso_email_mismatch: 'The account you signed in with does not match your email. Please sign in with the account for {{email}}.',
      auth_mode_sso_retry_hint: 'Click the button below to sign in again with the correct account.',
      auth_mode_sso_handshake_failed: 'Sign-in failed. Please try again.',
      auth_mode_sso_cancelled: 'Sign-in was cancelled.',
      auth_mode_sso_signing_in: 'Signing in...',
      auth_mode_sso_continue_google: 'Sign in with Google',
      auth_mode_sso_continue_microsoft: 'Sign in with Microsoft',
      auth_mode_sso_popup_blocked: 'Popup was blocked. Please allow popups for this site and try again.',
      auth_mode_set_password_prompt: 'Set your new password to stay signed in.',
      auth_mode_set_password: 'Set your password.',
      auth_mode_new_password: 'New password',
      auth_mode_confirm_password: 'Confirm password',
      auth_mode_password_min_length: 'Password must be at least 8 characters.',
      auth_mode_password_mismatch: 'Passwords do not match.',
      auth_mode_password_requirements: 'Password must meet all requirements (8+ characters, upper & lower case, number, special character).',
      leave_blank:
        "Leave this blank if you don't plan on changing the password",
      leave_blank_if_no_change:
        "Leave blank if you don't plan on changing your password",
      enter_current_password: 'Enter your current password',
      enter_new_password: 'Enter new password',
      confirm_new_password: 'Confirm new password',
      password_requirements: 'Password Requirements:',
      password_must_include: 'Your password must include:',
      requirement_length: 'At least 8 characters',
      requirement_number: 'At least 1 number',
      requirement_uppercase: 'At least 1 uppercase letter',
      requirement_uppercase_az: 'At least one uppercase letter (A-Z)',
      requirement_lowercase_az: 'At least one lowercase letter (a-z)',
      requirement_number_09: 'At least one number (0-9)',
      requirement_special_eg: 'At least one special character (e.g., !, @, #, $)',
      requirement_special: 'At least 1 special character',
      requirement_lowercase: 'At least 1 lowercase letter',
      update_password_description: 'Update your password to keep your account secure',
      mfa_current_method: 'Current Method',
      mfa_current_methods: 'Current Methods',
      mfa_totp_configured_status: 'Authenticator app is configured and ready to use.',
      mfa_using_totp: 'Authenticator App',
      mfa_using_sms: 'SMS',
      mfa_phone_number: 'Phone Number',
      mfa_change_phone: 'Change',
      mfa_switch_to_totp: 'Switch to Authenticator App',
      mfa_switch_to_sms: 'Switch to SMS',
      mfa_use_totp: 'Use Authenticator App',
      mfa_use_sms: 'Use SMS',
      mfa_setup_totp: 'Set Up Authenticator App',
      mfa_setup_sms: 'Set Up SMS',
      mfa_setup_required: 'Please set up at least one two-factor authentication (2FA) method. You can set up both for added security:',
      mfa_choose_method: 'Choose your preferred two-factor authentication (2FA) method before enabling:',
      mfa_totp_configured: '✓ Authenticator App',
      mfa_sms_configured: '✓ SMS',
      mfa_configured_methods: 'Configured Methods',
      mfa_remove: 'Remove',
      mfa_add: 'Add',
      mfa_not_configured: 'Not configured',
      mfa_remove_confirm_title: 'Remove Authentication Method',
      mfa_remove_sms_confirm: 'Are you sure you want to remove SMS authentication? You will still have Authenticator App configured.',
      mfa_remove_totp_confirm: 'Are you sure you want to remove Authenticator App? You will still have SMS configured.',
      mfa_remove_error: 'Failed to remove method',
      transfer_ownership_title: 'Transfer Ownership',
      transfer_ownership_info: 'Transfer company ownership to another account admin. You will lose owner access and the selected account admin will become the new owner.',
      transfer_ownership_bullet_admins: 'Only account admins can be selected as the new owner',
      transfer_ownership_bullet_irreversible: 'This action cannot be undone',
      transfer_ownership_admins_label: 'Account admins',
      transfer_ownership_select_admin: 'Select an account admin',
      transfer_ownership_button: 'Transfer',
      transfer_ownership_confirm_title: 'Confirm transfer',
      transfer_ownership_confirm_message: 'Are you sure you want to transfer ownership to {{name}}? This action cannot be undone.',
      transfer_ownership_confirm_message_no_user: 'Are you sure you want to transfer ownership? This action cannot be undone.',
      transfer_ownership_success_title: 'Transfer complete',
      transfer_ownership_success_message: 'Ownership has been transferred successfully. You will be redirected to the home page.',
      choose_method_title: 'Two-Factor Authentication',
      choose_method_description: 'Select how you want to receive verification codes. You can set up both methods later for added security.',
      enable_with_totp: 'Enable with Authenticator App',
      enable_with_sms: 'Enable with SMS',
      authentication_mode_subtitle: 'Choose how users authenticate in your company',
      sso_contact_required: 'SSO requires special setup. Please contact support to enable this feature.',
      sso_contact_support: 'Contact support',
      authentication_mode_contact_support:
        'To change the authentication method, please contact support.',
      login_method_contact_support_prefix: 'If you wish to change your log in method, please contact us at ',
      authentication_mode_contact_support_prefix:
        'To change the authentication method, please contact ',
      authentication_mode_contact_support_link: 'support',
      invalid_email_for_sso: 'This email did not match the selected email.',
      invalid_email_for_microsoft: 'This email did not match the selected email.',
      change_password: 'Change Password',
      current_password: 'Current Password',
      password_changed: 'Password changed successfully',
      change_password_required: 'Change Your Password',
      password_set_by_admin: 'Your password was set by an administrator. Please change it now for security.',
      password_change_error: 'Failed to change password',
      delete: {
        delegate: {
          title: 'Account deletion',
          body1: 'Please email',
          body2: 'to proceed with your account deletion.',
        },
      },
    },
    referrals: {
      score_1: "Reference's email is not a Company domain",
      score_2: '{{company}} not found in Canadian federal databases',
      score_3: "Reference's email may not belong to {{company}}",
      worked_as: 'Worked as a ',
      work_period: 'Work period {{period}}',
      reference_status: 'Reference status{{updated}}',
      details: 'Details',
      reference_name: 'Reference name',
      reference_email: 'Reference email',
      request_reference: {
        text: 'Your talent has not shared any references with you yet.<br/>Request a reference by clicking on the button above',
        button: 'Request a reference',
      },
    },
    reset_password: {
      title: 'Forgot your password?',
      title_done: 'Thank you!',
      body: 'Enter your email to reset your password',
      body_done:
        'The password reset code has been sent. Please check your inbox.',
      codes: {
        EMAIL_REQUIRED: 'Email is required',
        ACCOUNT_NOT_FOUND: 'Account not found. Please check your email address.',
        PASSWORD_RESET_NOT_AVAILABLE: 'Password reset is not available for this account. Please sign in with your company sign-in method.',
        RESET_EMAIL_SENT: 'If an account exists with this email, you will receive a verification code shortly.',
        INTERNAL_ERROR: 'Something went wrong. Please try again later.',
        RESET_LINK_EXPIRED: 'This link has expired. Please request a new password reset.',
        INVALID_VERIFICATION_CODE: 'Invalid verification code. Please try again.',
        PASSWORD_RESET_SUCCESS: 'Your password has been reset. You can now sign in with your new password.',
        INVALID_PASSWORD: 'Your new password does not meet the requirements.',
      },
    },
    search_results: {
      title: 'All results for {{search}}',
      your_talents: 'Your talents',
      your_talents_SECURITY: 'Individuals',
      not_your_company: 'Not part of your company',
    },
    update_password: {
      body: 'Please enter a new password for your account',
      pass_requirements:
        'Must contain at least 1 number, 1 special character, 1 uppercase letter, 1 lowercase letter',
    },
    sso: {
      body: 'Please enter your organization domain',
    },
    mfa_request: {
      title: 'Two-Factor Authentication',
      body: 'Enter the one time code you received',
      not_received: "Didn't receive a code?",
      button: 'Verify',
    },
    plans: {
      change_plan: '{{changeType}} a {{newPlanType}} plan?',
      change_plan_final_step:
        'Your change will take effect as soon as you complete this step.',
      no_billing_info: 'No billing information found on file',
      no_billing_info_description:
        'A credit card is required to upgrade your plan',
      update_billing_info: 'Update billing info',
      invalid_plan: 'Invalid plan',
      company_not_registered: "Your company's plan has expired",
      company_not_registered_details:
        'Please contact your administrator to ensure you have an active subscription',
      unable_to_process_payment:
        'We were unable to process your payment for this month',
      update_billing: 'Update billing',
      missing_billing_info:
        "You don't have billing information on file. Add it before your next payment!",
    },
    plans_and_payments: {
      view_details: 'View details',
      current_plan: 'Current plan: {{plan_name}}',
      billing_cycle_ends: 'Your plan renews on: {{date}}',
      next_payment: 'Next payment {{next_payment}}',
      validations_made: 'Validations made',
      validations_remaining: 'validations remaining until',
      manage_subscription: 'Manage subscription',
      your_plan_breakdown: 'Your plan breakdown for this month:',
      purchased_bundles: 'Purchased bundles for this plan',
      available_bundles:
        'Reaching your plan limit? Add a bundle for a one time fee.',
      bundle_types: {
        additional_validations: 'validations',
        additional_users: 'users',
      },
      will_be_added: '{{count}} {{type}} will be added to your subscription.',
      will_be_charged: 'You will be charged as soon as you click "Purchase"',
      were_be_added: '{{count}} {{type}} were added to your subscription.',
      bundle_unavailable: 'Bundle unavailable',
      bundle_unavailable_free_trial:
        'You cannot add bundles with the Free Trial',
      bundle_unavailable_limit:
        'You must be closer to your plan limit to add a bundle',
      you_sure_cancel: 'Are you sure you want to cancel?',
      cancel_description_first:
        'You will lose access to the platform and will be charged',
      cancel_description_second:
        'based on the number of validations that have been used in your account',
      cancel_successful: 'Your subscritpion has been successfully cancelled',
      questions: 'Have questions? View our',
      online_conduct_report: 'Online conduct report',
      unlimited_job_confirmation: 'Unlimited job confirmation',
      users_per_company: 'users per company',
    },
    user_management: {
      teams: {
        type_PRIVATE: 'Private',
        type_SHARED: 'Shared',
        team: 'Team',
        teams: 'Teams',
        type: 'Type',
        users: 'Users',
        allocated_validations: 'Allocated Validations',
        available_validations: 'Completed Validations',
        remaining_validations: 'Remaining Validations',
        validations_available: '{{validations}} validations completed',
        add_team: 'Add Team',
        edit_team: 'Edit Team',
        delete_team: 'Delete Team',
        delete_step1_body:
          'Deletion of {{team}} team will move all users to general team. Remaining validations will be added to the account quota. You have the option to move the validations of this team to another or permanently delete them. Type "Delete Team" to confirm team deletion.',
        delete_button_1: 'Delete and move validations',
        delete_button_2: 'Permanently Delete',
        delete_button_3: 'Back',
        delete_button_4: 'Delete',
        private_validations: 'Private Validations',
        private_validations_info:
          'Allow team members to submit validations that will not be shared with other team members',
        disabled: 'Disabled',
        enabled: 'Enabled',
        min_vals_err:
          ' Number of validations must be greater than or equal to 0.',
      },
      users: {
        user: 'User',
        access_type: 'Access Type',
        status: 'Status',
        status_ACTIVE: 'Active',
        status_INACTIVE: 'Inactive',
        status_PENDING: 'Pending',
        add_user: 'Add User',
        edit_user: 'Edit User',
        role_ADMIN: 'Account Admin',
        role_OWNER: 'Account Owner',
        role_LEAD: 'Team Admin',
        role_MEMBER: 'Team Member',
        resend_invitation: 'Resend Invitation',
        invitation_resent: 'Invitation resent to {{email}}',
      },
    },
    lev_report: {
      summary_details: {
        box_1:
          'The results below report adverse online information around Environmental, Social and Governance factors as established by common ESG standards and frameworks.',
        box_2:
          'Reports flagged in yellow contain adverse information online related to the corresponding ESG pillar that mentions the designated company.',
        box_3:
          'A green indicator means no ESG-based adverse information is found online by our AI models.',
        ENVIRONMENT: {
          title: 'Environmental',
          description:
            'Results are based on publicly available online information linking an organization to adverse environmental events. A yellow indicator signals unfavourable information based on ESG factors.',
        },
        FINANCIAL: {
          title: 'FINANCIAL',
          description: '',
        },
        SOCIAL: {
          title: 'Social',
          description:
            'Results are based on publicly available online information linking an organization to adverse social events. A yellow indicator signals unfavourable information based on ESG factors.',
        },
        GOVERNANCE: {
          title: 'Governance',
          description:
            'Results are based on publicly available online information linking an organization to adverse governance events.  A yellow indicator signals unfavourable information based on ESG factors. ',
        },
        OTHER: {
          title: 'Other',
          description:
            'Adverse media results are flagged here when they fall outside globally recognized ESG guidelines.',
        },
      },
      categories: {
        ENVIRONMENT: 'Environmental',
        FINANCIAL: 'Financial',
        SOCIAL: 'Social',
        GOVERNANCE: 'Governance',
        OTHER: 'Other',
      },
    },
    report: {
      summary: {
        words: '{{count}} words',
        view: 'View Summary',
        request: 'Summarize',
        loading: 'Loading...',
        unavailable: 'The summary of this article is not available.',
        error:
          'Unable to extract summary from this article. Please contact support if you need assistance.',
        noCredits: 'No more credits!',
        creditsError:
          'All {{count}} summaries have been used. Please contact the account owner to request additional summaries from support@valital.com.',
        requestMore: 'Request More',
      },
      executive_summary: {
        title: 'Executive Summary',
        show_more: 'Show more',
        show_less: 'Show less',
        view_from_list: 'Executive Summary',
        dialog_title: 'Executive Summary of {{name}}',
        validation_last_updated: 'Validation last updated',
        none_available:
          'The Executive Summary is not available for this validation.',
        processing_message:
          'The validation is still processing. The summary will be available shortly.',
      },
      verified_estimate: {
        validation_under_review: 'Your most recent validation is under review.',
        ready_shortly: 'It should be ready shortly...',
        ready_monday:
          'The updated report will be available by 1 pm on Monday. We will notify you by email when it’s ready.',
        ready_in_24: `The updated report will be available within {{hours}}h. We will notify you by email when it’s ready.`,
      },
      history: {
        history: 'History',
        no_activities: 'This user has no activities',
        activities: {
          toggled_live_update: 'LiveUpdate activated by {{user}}.',
          toggled_live_update_off: 'LiveUpdate deactivated by {{user}}.',
          added_individual:
            '{{employment}} was added to your company by {{user}}.',
          added_talent:
            '{{employment}} was invited to your company by {{user}}.',
          invitation_accepted:
            '{{employment}} accepted the invitation to your company.',
          invitation_declined:
            '{{employment}} declined the invitation to your company.',
          // New and adjusted entries below
          started_validation: 'Validation started by {{user}}.', // Adjusted for consistency
          preliminary_report: 'Preliminary report ready.',
          completed_report_ready:
            'Completed report ready. Risk Indicator is {{riskIndicator}}.',
          validation_updated: 'Validation updated by {{user}}.',
          live_update_activated: 'LiveUpdate activated by {{user}}.',
          live_update_deactivated: 'LiveUpdate deactivated by {{user}}.',
          risk_indicator_is: 'Risk Indicator is {{riskIndicator}}.', // For standalone Risk Indicator updates
          validation_reviewed: 'Validation reviewed by {{user}}.',
          validation_archived: 'Validation archived by {{user}}.',
          validation_unarchived: 'Validation unarchived by {{user}}.',
          validation_report_updated: 'Validation report has been updated.',
          new_articles_reported:
            '{{newArticles}} new articles reported from LiveUpdate.',
          risk_indicator_remains: 'Risk Indicator remains {{riskIndicator}}.',
          risk_indicator_now: 'Risk Indicator is now {{riskIndicator}}.',
          published_validation: 'Validation report has been updated.',
          from_live_update: 'New articles reported from LiveUpdate.',
          conduct_changed: 'Risk Indicator is now ',
          lev_conduct_changed: 'Risk Indicator is now ',
          conduct_unchanged: 'Risk Indicator remains ',
          lev_conduct_unchanged: 'Risk Indicator remains ',
          sharing_reference_shared:
            '{{employment}} shared a reference from {{reference}} with your company.',
          sharing_reference_unshared:
            '{{employment}} unshared a reference from {{reference}} with your company.',
          confirming_reference_confirmed:
            "A reference from {{reference}} has confirmed {{employment}}'s employment.",
          confirming_reference_declined:
            "A reference from {{reference}} has declined {{employment}}'s employment.",
          reviewed_by: 'Validation reviewed by {{name}}.',
        },
      },
      subCategories: {
        ADDICTION: 'Addiction',
        DISCRIMINATION: 'Discrimination',
        'FINANCIAL CRIME': 'Financial Crime',
        HARASSMENT: 'Harassment',
        VIOLENCE: 'Violence',
        NEWS: 'News',
        LITIGATION: 'Litigations',
        TWITTERFLAGS: 'Flagged Tweets',
        ENVIRONMENT: 'Environmental',
        FINANCIAL: 'Financial',
        SOCIAL: 'Social',
        GOVERNANCE: 'Governance',
        OTHER: 'Other',
        ASSAULT: 'Assault',
        'DOMESTIC VIOLENCE': 'Domestic Violence',
        RIOT: 'Riot',
        'SEXUAL VIOLENCE': 'Sexual Violence',
        TRAFFICKING: 'Trafficking',
        SLAVERY: 'Slavery',
        EXTORTION: 'Extortion',
        'ROBBERY/BURGLARY': 'Robbery/Burglary',
        'SUBSTANCE ABUSE': 'Substance Abuse',
        GAMBLING: 'Gambling',
        DUI: 'DUI',
        'VERBAL AND PSYCHOLOGICAL HARASSMENT':
          'Verbal and Psychological Harassment',
        'PHYSICAL AND SEXUAL HARASSMENT': 'Physical and Sexual Harassment',
        'ABUSE OF AUTHORITY': 'Abuse of Authority',
        CORRUPTION: 'Corruption',
        'MONEY LAUNDERING': 'Money Laundering',
        THEFT: 'Theft',
        'TAX EVASION': 'Tax Evasion',
        'INSIDER TRADING': 'Insider Trading',
        'SCAM/HACK': 'Scam/Hack',
        'AGE DISCRIMINATION': 'Age Discrimination',
        'RELIGIOUS DISCRIMINATION': 'Religious Discrimination',
        'RACIAL DISCRIMINATION': 'Racial Discrimination',
        'GENDER DISCRIMINATION': 'Gender Discrimination',
        'SEXUAL ORIENTATION DISCRIMINATION':
          'Sexual Orientation Discrimination',
        'DISABILITY DISCRIMINATION': 'Disability Discrimination',
        'PERSONAL CONFLICT': 'Personal Conflict',
        'COMMERCIAL CONFLICT': 'Commercial Conflict',
        'FALSE ACCUSATION': 'False Accusation',
        'BREACH OF OBLIGATION': 'Breach of Obligation',
        STRIKE: 'Strike',
        CONTAMINATION: 'Contamination',
        POLLUTION: 'Pollution',
        WASTE: 'Waste',
        'WASTE EMISSION': 'Waste',
        EMISSION: 'Emission',
        EXPLOITATION: 'Exploitation',
        'LABOUR UNREST': 'Labour Unrest',
        SHUTDOWN: 'Shutdown',
        'HUMAN RIGHTS VIOLATION': 'Human Rights Violation',
        LAYOFF: 'Layoff',
        UNDERPAYING: 'Underpaying',
        'HEALTH & SAFETY VIOLATION': 'Health & Safety Violation',
        'CYBER BREACH/CRIME': 'Cyber Breach/Crime',
        ANTITRUST: 'Antitrust',
        SANCTIONS: 'Sanctions',
        'SMUGGLING/TRAFFICKING': 'Smuggling/Trafficking',
        'BREACH OF OBLIGATIONS': 'Breach of Obligations',
        'FINANCIAL MISCONDUCT': 'Financial Misconduct',
        'BANKRUPTCY/OUT OF BUSINESS': 'Bankruptcy/Out of business',
        DELISTING: 'Delisting',
        DIVESTURE: 'Divesture',
        'STOCK DOWNGRADE': 'Stock Downgrade',
        RESTRUCTURING: 'Restructuring',
        LOSSES: 'Losses',
        'UNDER REPORTING': 'Under Reporting',
        'TERRORIST FINANCING': 'Terrorist Financing',
        ABLEISM: 'Ableism',
        FRAUD: 'Fraud',
        VANDALISM: 'Vandalism',
        PROSTITUTION: 'Prostitution',
        TERRORISM: 'Terrorism',
        MURDER: 'Murder',
        KIDNAPPING: 'Kidnapping',
        TORTURE: 'Torture',
        ARSON: 'Arson',
        GENOCIDE: 'Genocide',
        DEFORESTATION: 'Deforestation',
        DUMPING: 'Dumping',
        NEGLIGENCE: 'Negligence',
        DEFAMATION: 'Defamation',
        'ANIMAL CRUELTY': 'Animal Cruelty',
        LAYOFFS: 'Layoffs',
        'HEALTH AND SAFETY VIOLATION': 'Health and Safety Violation',
        'LABOUR UNREST/SHUTDOWN': 'Labour Unrest/Shutdown',
        'CYBER CRIME/BREACH': 'Cyber Crime/Breach',
        'FRAUD/THEFT': 'Fraud/Theft',
        'TRAFFICKING/SLAVERY': 'Trafficking/Slavery',
        'TERRORISM/GENOCIDE': 'Terrorism/Genocide',
        'AGE DISCRIMINATION (AGEISM)': 'Age Discrimination (ageism)',
        'RELIGIOUS/RACIAL DISCRIMINATION': 'Religious/Racial Discrimination',
        'SEXUAL ORIENTIATION DISCRIMINATION': 'Sexual Orientiation Discrimination',
        'DISABILITY DISCRIMINATION (ABLEISM)': 'Disability Discrimination (ableism)',
        'BREACH OF OBLIGATION/CONTRACT': 'Breach of Obligation/Contract',
      },
      strong_id_match: 'Strong Match',
      weak_id_match: 'Possible Match',
      potential_false_positive_id_match: 'Weak Match',
      id_match_tiers: {
        strong_match: 'Strong Match',
        possible_match: 'Possible Match',
        weak_match: 'Weak Match',
        below_threshold: 'Identity Match',
      },
      very_weak_id_match: 'Very Weak ID Match',
      percentage_id: '{{percentage}}%',
      more_than_90: 'More than 90',
      accused: 'Participant',
      victim: 'Referenced',
      english: 'EN',
      french: 'FR',
      spanish: 'ES',
      portuguese: 'PT',
      undefined: 'Subject of the action not analyzed',
      showing_results: 'Showing {{count}} result',
      showing_results_plural: 'Showing {{count}} results',
      showing_results_events: 'Showing {{count}} event',
      showing_results_plural_events: 'Showing {{count}} events',
      event_singular: 'event',
      event_plural: 'events',
      link_singular: 'link',
      link_plural: 'links',
      showing_results_events_and_links: 'Showing {{eventCount}} {{eventWord}} and {{linkCount}} {{linkWord}}',
      empty_conduct: {
        title: 'Your report is underway!',
        description:
          'Fast is good; accuracy is even better. We know which you value most.',
        lev_description:
          'Good reports come to those who wait...just a little while longer.',
      },
      extended_report: {
        notice:
          'The results below may include articles that fall below our ID matching threshold. Expect more false positives since the extended search has been enabled.',
      },
      languageOptions: {
        english: 'English',
        french: 'French',
        spanish: 'Spanish',
        portuguese: 'Portuguese',
      },
      categories: {
        'HIGH RISK': 'High Risk',
        INVESTIGATE: 'Investigate',
        'WEAK MATCH': 'Inconclusive',
        CLEAR: 'Clear',
      },
      grouping: {
        relevant_links: 'Relevant Link(s)',
        multi_source_events: 'Grouped Event(s)',
        non_grouped_links: 'Ungrouped Event(s)',
        events: 'Events',
      },
      pep: 'PEP',
      soe: 'SOE',
      order: {
        label: 'Order',
        changeOrder: 'Change Order',
        applyForAllReports: 'Set as Default for all reports',
        applyForThisReport: 'Save for this report',
        lastSavedAt: 'Last saved at {{time}}',
        status: 'Risk Indicator',
        seen_at: 'Last Seen',
        idm: 'Identity Match',
        pub_date: 'Publishing Date',
        createdAt: 'Validation Date',
        reset: 'Reset',
      },
      review: {
        title: 'Review report',
        description: 'Are you sure you want to mark entire report as reviewed?',
        action: 'yes',
        error: 'An error occured while marking the report as reviewed.',
        reviewed_by: 'Reviewed on {{date}} by {{user}}',
        validated_by: 'Validated on {{date}} by {{user}}',
        mark_as_reviewed: 'Mark as Reviewed',
      },
      hiddenLinks: {
        label: 'Hidden Links',
        label_singular: 'Hidden Link',
        confirmDelete: 'Are you sure you want to remove all hidden links?',
        confirmHideTitle: 'Hide Link',
        confirmShowTitle: 'View Link',
        confirmShow: 'Are you sure you want to show this link?',
        confirmHide: 'Are you sure you want to hide this link?',
        confirm: 'Confirm',
        cancel: 'Cancel',
        delete: 'Delete',
      },
      filters: {
        label: 'Filter',
        category: 'Category',
        filter_articles: 'Filter articles',
        topics: 'Topics',
        noSubtopic: 'No subtopics have been identified.',
        applyForAllReports: 'Set as Default for all reports',
        applyForThisReport: 'Save for this report',
        reset: 'Reset',
        clear: 'Clear',
        general: {
          idMatch: {
            main: 'Identity Match',
            STRONG: {
              main: 'Strong',
              sentence: 'Strong',
            },
            POSSIBLE: {
              main: 'Possible',
              sentence: 'Possible',
            },
            WEAK_MATCH: {
              main: 'Weak',
              sentence: 'Weak',
            },
            VERY_WEAK: {
              main: 'Very Weak',
              sentence: 'Very Weak Identity Match',
            },
          },
          language: {
            main: 'Language of the Article',
            ENGLISH: {
              main: 'EN',
              sentence: 'English',
            },
            FRENCH: {
              main: 'FR',
              sentence: 'French',
            },
            SPANISH: {
              main: 'ES',
              sentence: 'Spanish',
            },
            PORTUGUESE: {
              main: 'PT',
              sentence: 'Portuguese',
            },
          },
          sourceCategory: {
            main: 'Source of Information',
            mainstream_media: {
              sentence: 'Mainstream Media',
            },
            government_agencies: {
              sentence: 'Government Agencies',
            },
            legitimate_online_database: {
              sentence: 'Legal Databases',
            },
            education_professional_associations: {
              sentence: 'Recognized Institutions',
            },
            strong_content: {
              sentence: 'Strong Content Quality',
            },
            user_source: {
              sentence: 'My Sources',
            },
            not_verified: {
              sentence: 'Unverified',
            },
          },
          articleType: {
            main: 'Article Type',
            LIVE: {
              main: 'Live',
              sentence: 'Live Articles',
            },
            INSTANT: {
              main: 'Instant',
              sentence: 'Instant Articles',
            },
          },
          source: {
            main: 'Source',
            CREDIBLE: {
              main: 'Verified',
              sentence: 'Verified Source',
            },
            NOT_CREDIBLE: {
              main: 'Unverified',
              sentence: 'Unverified Source',
            },
          },
          riskIndicator: {
            main: 'Risk Indicator',
            'HIGH RISK': { sentence: 'High Risk' },
            INVESTIGATE: { sentence: 'Investigate' },
            CLEAR: { sentence: 'Clear' },
            'WEAK MATCH': { sentence: 'Inconclusive' },
          },
          hasPep: {
            true: { sentence: 'PEP' },
          },
          hasSoe: {
            true: { sentence: 'SOE' },
          },
          topic: {
            main: 'Topics',
            LITIGATION: { sentence: 'Litigations' },
            VIOLENCE: { sentence: 'Violence' },
            HARASSMENT: { sentence: 'Harassment' },
            ADDICTION: { sentence: 'Addiction' },
            NEWS: { sentence: 'News' },
            FINANCIAL: { sentence: 'Financial' },
            'FINANCIAL CRIME': { sentence: 'Financial Crime' },
            DISCRIMINATION: { sentence: 'Discrimination' },
            ENVIRONMENT: { sentence: 'Environmental' },
            SOCIAL: { sentence: 'Social' },
            GOVERNANCE: { sentence: 'Governance' },
            OTHER: { sentence: 'Other' },
          },
          subTopic: {
            main: 'Subtopics',
            MAIN: 'Subtopics',
            ASSAULT: { sentence: 'Assault' },
            'DOMESTIC VIOLENCE': { sentence: 'Domestic Violence' },
            RIOT: { sentence: 'Riot' },
            'SEXUAL VIOLENCE': { sentence: 'Sexual Violence' },
            TRAFFICKING: { sentence: 'Trafficking' },
            SLAVERY: { sentence: 'Slavery' },
            EXTORTION: { sentence: 'Extortion' },
            'ROBBERY/BURGLARY': { sentence: 'Robbery/Burglary' },
            'SUBSTANCE ABUSE': { sentence: 'Substance Abuse' },
            GAMBLING: { sentence: 'Gambling' },
            DUI: { sentence: 'DUI' },
            HARASSMENT: { sentence: 'Harassment' },
            'ABUSE OF AUTHORITY': { sentence: 'Abuse of Authority' },
            'VERBAL AND PSYCHOLOGICAL HARASSMENT': {
              sentence: 'Verbal and Psychological Harassment',
            },
            'PHYSICAL AND SEXUAL HARASSMENT': {
              sentence: 'Physical and Sexual Harassment',
            },
            CORRUPTION: { sentence: 'Corruption' },
            'MONEY LAUNDERING': { sentence: 'Money Laundering' },
            THEFT: { sentence: 'Theft' },
            'TAX EVASION': { sentence: 'Tax Evasion' },
            'INSIDER TRADING': { sentence: 'Insider Trading' },
            'SCAM/HACK': { sentence: 'Scam/Hack' },
            'AGE DISCRIMINATION': { sentence: 'Age Discrimination' },
            'RELIGIOUS DISCRIMINATION': {
              sentence: 'Religious Discrimination',
            },
            'RACIAL DISCRIMINATION': { sentence: 'Racial Discrimination' },
            'GENDER DISCRIMINATION': { sentence: 'Gender Discrimination' },
            'SEXUAL ORIENTATION DISCRIMINATION': {
              sentence: 'Sexual Orientation Discrimination',
            },
            'DISABILITY DISCRIMINATION': {
              sentence: 'Disability Discrimination',
            },
            'PERSONAL CONFLICT': { sentence: 'Personal Conflict' },
            'COMMERCIAL CONFLICT': { sentence: 'Commercial Conflict' },
            'FALSE ACCUSATION': { sentence: 'False Accusation' },
            'BREACH OF OBLIGATION': { sentence: 'Breach of Obligation' },
            STRIKE: { sentence: 'Strike' },
            CONTAMINATION: { sentence: 'Contamination' },
            POLLUTION: { sentence: 'Pollution' },
            WASTE: { sentence: 'Waste' },
            'WASTE EMISSION': { sentence: 'Waste' },
            EMISSION: { sentence: 'Emission' },
            DISCRIMINATION: { sentence: 'Discrimination' },
            EXPLOITATION: { sentence: 'Exploitation' },
            'LABOUR UNREST': { sentence: 'Labour Unrest' },
            SHUTDOWN: { sentence: 'Shutdown' },
            'HUMAN RIGHTS VIOLATION': { sentence: 'Human Rights Violation' },
            LAYOFF: { sentence: 'Layoff' },
            UNDERPAYING: { sentence: 'Underpaying' },
            'HEALTH & SAFETY VIOLATION': {
              sentence: 'Health & Safety Violation',
            },
            'CYBER BREACH/CRIME': { sentence: 'Cyber Breach/Crime' },
            ANTITRUST: { sentence: 'Antitrust' },
            LITIGATION: { sentence: 'Litigation' },
            SANCTIONS: { sentence: 'Sanctions' },
            'SMUGGLING/TRAFFICKING': { sentence: 'Smuggling/Trafficking' },
            'BREACH OF OBLIGATIONS': { sentence: 'Breach of Obligations' },
            'FINANCIAL MISCONDUCT': { sentence: 'Financial Misconduct' },
            'BANKRUPTCY/OUT OF BUSINESS': {
              sentence: 'Bankruptcy/Out of business',
            },
            DELISTING: { sentence: 'Delisting' },
            DIVESTURE: { sentence: 'Divesture' },
            'STOCK DOWNGRADE': { sentence: 'Stock Downgrade' },
            RESTRUCTURING: { sentence: 'Restructuring' },
            LOSSES: { sentence: 'Losses' },
            'UNDER REPORTING': { sentence: 'Under Reporting' },
            'TERRORIST FINANCING': { sentence: 'Terrorist Financing' },
            ABLEISM: { sentence: 'Ableism' },
            FRAUD: { sentence: 'Fraud' },
            VANDALISM: { sentence: 'Vandalism' },
            PROSTITUTION: { sentence: 'Prostitution' },
            TERRORISM: { sentence: 'Terrorism' },
            MURDER: { sentence: 'Murder' },
            KIDNAPPING: { sentence: 'Kidnapping' },
            TORTURE: { sentence: 'Torture' },
            ARSON: { sentence: 'Arson' },
            GENOCIDE: { sentence: 'Genocide' },
            DEFORESTATION: { sentence: 'Deforestation' },
            DUMPING: { sentence: 'Dumping' },
            NEGLIGENCE: { sentence: 'Negligence' },
            DEFAMATION: { sentence: 'Defamation' },
            'ANIMAL CRUELTY': { sentence: 'Animal Cruelty' },
            LAYOFFS: { sentence: 'Layoffs' },
            'HEALTH AND SAFETY VIOLATION': { sentence: 'Health and Safety Violation' },
            'LABOUR UNREST/SHUTDOWN': { sentence: 'Labour Unrest/Shutdown' },
            'CYBER CRIME/BREACH': { sentence: 'Cyber Crime/Breach' },
            'FRAUD/THEFT': { sentence: 'Fraud/Theft' },
            'TRAFFICKING/SLAVERY': { sentence: 'Trafficking/Slavery' },
            'TERRORISM/GENOCIDE': { sentence: 'Terrorism/Genocide' },
            'AGE DISCRIMINATION (AGEISM)': { sentence: 'Age Discrimination (ageism)' },
            'RELIGIOUS/RACIAL DISCRIMINATION': { sentence: 'Religious/Racial Discrimination' },
            'SEXUAL ORIENTIATION DISCRIMINATION': { sentence: 'Sexual Orientiation Discrimination' },
            'DISABILITY DISCRIMINATION (ABLEISM)': { sentence: 'Disability Discrimination (ableism)' },
            'BREACH OF OBLIGATION/CONTRACT': { sentence: 'Breach of Obligation/Contract' },
          },
          events: {
            main: 'Events',
            multi_source_events: { sentence: 'Grouped' },
            non_grouped_links: { sentence: 'Non-Grouped' },
            relevant_links: { sentence: 'Relevant Link(s)' },
          },
          publishDate: {
            main: 'Publishing Date',
            include: 'Include articles with no publishing date',
            selectPresetRange: 'Select',
            range: 'Published between {{start}} and {{end}}',
            by: 'By',
            from: 'from ',
            to: 'to',
            fromStart: 'From {{start}}',
            toEnd: 'Until {{end}}',
            startDate: 'Published from {{start}}',
            endDate: 'Published to {{end}}',
            noDate: 'No publishing date',
            yesterday: 'Since yesterday',
            custom: 'Custom',
            thisMonth: 'This month',
            lastYear: 'Last 12 months',
            last6Months: 'Last 6 months',
            last3Months: 'Last 3 months',
            last2Years: 'Last 2 years',
            last5Years: 'Last 5 years',
            clear: 'Clear',
            apply: 'Apply',
          },
          validationDate: {
            main: 'Validation Date',
            selectPresetRange: 'Select',
            range: 'Validated between {{start}} and {{end}}',
            by: 'By',
            from: 'from ',
            to: 'to',
            fromStart: 'From {{start}}',
            toEnd: 'Until {{end}}',
            startDate: 'Validated from {{start}}',
            endDate: 'Validated to {{end}}',
            yesterday: 'Since yesterday',
            custom: 'Custom',
            thisMonth: 'This month',
            lastYear: 'Last 12 months',
            last6Months: 'Last 6 months',
            last3Months: 'Last 3 months',
            last2Years: 'Last 2 years',
            last5Years: 'Last 5 years',
            clear: 'Clear',
            apply: 'Apply',
          },
          subject: {
            main: 'Role',
            direct_participant: {
              main: 'Direct Participant',
              sentence: 'Direct Participant',
            },
            involved: {
              main: 'Involved',
              sentence: 'Involved',
            },
            referenced: {
              main: 'Referenced',
              sentence: 'Referenced',
            },
          },
          extendReport: {
            main: 'Extended Report',
            TRUE: {
              main: 'Yes',
              sentence: 'Is Extended Report',
            },
            FALSE: {
              main: 'No',
              sentence: 'Is not Extended Report',
            },
          },
        },
        validations: {
          show_archived_only: 'Show archived validations',
          show_not_archived_only: 'Show active validations',
          show_all: 'Show all validations',
          privacy: 'Sharing',
          show_private: 'Private validations',
          show_public: 'Shared validations',
          team: 'Team',
        },
      },
      theme: {
        ADDICTION: 'Addiction',
        DISCRIMINATION: 'Discrimination',
        'FINANCIAL CRIME': 'Financial Crime',
        HARASSMENT: 'Harassment',
        VIOLENCE: 'Violence',
        NEWS: 'News',
        LITIGATION: 'Litigations',
        TWITTERFLAGS: 'Flagged Tweets',
      },
      lev_theme: {
        ENVIRONMENT: 'Environmental',
        FINANCIAL: 'Financial',
        SOCIAL: 'Social',
        GOVERNANCE: 'Governance',
        OTHER: 'Other',
      },
      conduct_summary: {
        title: 'At a glance',
        identity_weak_match_card: 'Weak Match',
        weak_match_card: 'Inconclusive',
        inconclusive_card: 'Inconclusive',
        beta_label: 'Beta',
        how_to_read_this_report: 'How to read this report',
        no_articles_found: 'No articles found on {{misconduct}}',
        articles_analyzed:
          ' Relevant Links identified out of more than {{found}} links analyzed',
      },
      twitter: {
        flagged_on: 'Flagged on',
        title:
          'Activity flagged for misconduct for <2>@{{twitter_screen_name}}</2>',
        tweets_flagged:
          '{{flagged}} out of {{analyzed}} tweets flagged in the latest analysis',
        tweets_flagged_date:
          '{{flagged}} out of {{analyzed}} tweets flagged in the latest analysis ({{start}} - {{end}})',
        no_twitter_account: {
          title:
            'We don’t have a twitter username associated to this individual.',
          subtitle:
            'Link a twitter account below or update the individual’s validation.',
          button: 'Run twitter analysis',
        },
        no_tweets: {
          title:
            "We couldn't find any tweets to analyze on <2>@{{twitter_screen_name}}</2>",
          subtitle:
            'This could be because the account is private or the username does not exist.',
        },
        all_good: {
          title:
            "We've analyzed {{analyzed}} tweets and found no flagged behavior for @{{twitter_screen_name}}",
          zero_retrieved:
            'We found 0 {{tweetsOrRetweets}} for @{{twitter_screen_name}}',
        },
      },
      summary_details: {
        clear_title: 'Clear',
        clear_description: `Articles`,
        Reference_description: 'Reference',
        clear_description_ind: `the individual, however the individual is neither a Direct Participant nor Involved in a misconduct.`,
        clear_description_lev: `the organization, however the organization is neither a Direct Participant nor Involved in a misconduct.`,
        OR: `OR`,
        investigate_title: 'Investigate',
        investigate_description_ind1: `However, the match to your subject may be uncertain or only partial, or the source may be unverified. Alternatively, the articles refer to the individual as`,
        investigate_description_lev1:`However, the match to your subject may be uncertain or only partial, or the source may be unverified. Alternatively, the articles refer to the organization as`,
        involved_description: 'Involved',
        investigate_description_ind3: `in misconduct, regardless of the IDM.`,
        investigate_description_lev3: `in adverse information, regardless of the IDM.`,      
        high_risk_title: 'High Risk',
        articles_rerfer_individual: `Articles refer to the individual as a`,
        articles_rerfer_lev: `Articles refer to the organization as a`,        
        direct_participant: `Direct Participant`,
        high_risk_description: `in a misconduct. The link appears to match your subject strongly and the source is verified.`,
        high_risk_description_lev: `in adverse information. The link appears to match your subject strongly and the source is verified.`,        
        twitter_title: 'Flagged Tweets',
        twitter_description:
          'Tweets and retweets are flagged if the content and context fall within the five  misconduct categories. The use of foul or inappropriate language is also flagged.',
        relevant_links: 'Relevant Link(s)',
        relevant_links_description: `Relevant links are ones that meet our minimum match threshold. Each link is also labeled by match strength (Strong, Possible, or Weak). The High Risk, Investigate, and Clear totals at a glance include only Strong and Possible matches.`,
        relevant_links_lev_description: `Relevant links are adverse-news items that meet our minimum match threshold, with match strength shown as Strong, Possible, or Weak. High Risk, Investigate, and Clear totals include only Strong and Possible matches.`,
        executive_summary_how_to_read_title: 'Executive Summary',
        executive_summary_how_to_read_description: `A structured overview of results, focusing on Strong and Possible identity matches, with key events presented in chronological order to support clear and efficient risk assessment.`,
        identity_weak_match_title: 'Weak Match',
        identity_weak_match_description:
          'Weak Match is for links where our checks suggest a weaker link to your subject than Strong or Possible Match. They are not added to the High Risk, Investigate, or Clear totals; use the grey Weak Match card to see and filter them.',
        weak_match_title: 'Inconclusive',
        weak_match_how_to_read_description_iv:
          'Results identified as Weak matches, where available information is insufficient to establish a clear association with the entity. These findings do not contribute to the overall risk assessment and PEP identification.',
        weak_match_how_to_read_description_lev:
          'Results identified as Weak matches, where available information is insufficient to establish a clear association with the entity. These findings do not contribute to the overall risk assessment and SOE identification.',
        events: 'Events',
        events_description: 'An adverse event identified from one or more sources.',
        pep: 'PEP',
        pep_description:
          'Articles flagged in real time from global sources, identifying an individual as a Politically Exposed Person. (PEP)',
        soe: 'SOE',
        soe_description:
          'A partially or wholly State-Owned Enterprise (SOE) is identified using open source intelligence and generative AI analysis.',
        total_articles_event: `Event contains: {{articles}} links`,
        show_link: 'View Link',
        single_source: 'Single source',
        view_less: 'View Less',
        view_all: 'View All',
      },
      articles_found: {
        title: 'Reported Links',
        empty_title: 'All good!',
        empty_description: "We didn't find any article for this section",
        source_is_credible: 'Source credibility validated',
      },
      profile: {
        year_of_birth: 'Year of Birth',
      },
      load_more: 'Load more',
      article_roles: {
        direct_participant: 'Direct Participant',
        involved: 'Involved',
        referenced: 'Referenced',
      },
    },
    lev_csv_form: {
      validate_from_csv: 'Validate From CSV',
      heading: 'Your CSV file must have the following columns:',
      subheading: 'You will be able to edit prior to submitting.',
      download_template: 'Download Template',
      downloaded_template: 'Valital-Organization-CSV-Template.csv',
      upload_file: 'Upload File',
      fix_errors: 'You must fix all errors before submitting.',
      bullets: {
        organization_name: 'Organization name',
        acronym: 'Acronym (optional)',
        other_name: 'Other Name (optional)',
        city: 'City (optional)',
        province: 'Province / State (optional)',
        country: 'Country (optional)',
        industry: 'Industry',
        live_update: 'Live Update (true or false)',
      },
      error: {
        name_missing: 'Missing Organization Name',
        industry_missing: 'Missing industry',
      },
    },
    csv_form: {
      import_csv: 'Import From CSV',
      validate_from_csv: 'Validate From CSV',
      heading: 'Your CSV file must have the following columns:',
      subheading: 'You will be able to edit prior to submitting.',
      download_template: 'Download Template',
      downloaded_template: 'Valital-Individual-CSV-Template.csv',
      upload_file: 'Upload File',
      fix_errors: 'You must fix all errors before submitting.',
      error: {
        first_name_missing: 'Missing First Name',
        last_name_missing: 'Missing Last Name',
        last_name_invalid: 'Last Name invalid',
        first_name_invalid: 'First Name invalid',
        city_invalid: 'Invalid city',
        location_invalid: 'Invalid location',
        roles_no_company: 'Title with no matching organisation',
        too_many_companies: 'More than 3 organizations',
        too_many_nickname: 'One alternative first name maximum',
        twitter_name_invalid: 'Twitter handle invalid',
      },
      bullets: {
        first_name: 'First Name',
        last_name: 'Last Name',
        nick_name: 'Alternative First Name (optional)',
        alternative_first_name: 'Alternative First Name (optional)',
        // year_of_birth: 'Year of Birth',
        city: 'City',
        province: 'Province / State',
        country: 'Country',
        year_of_birth: 'Year of Birth (optional)',
        company1:
          'Organization 1 (An Organization the individual is affiliated with)',
        role1: 'Role 1 (Role at Organization 1)',
        company2:
          'Organization 2 (An Organization the individual is affiliated with)',
        role2: 'Role 2 (Role at Organization 2)',
        company3:
          'Organization 3 (An Organization the individual is affiliated with)',
        role3: 'Role 3 (Role at Organization 3)',
        twitter: 'Twitter Username (optional)',
        live_update: 'Live Update (true or false)',
        extended_report: 'Extended Search (true or false)',
        labels: 'Labels',
      },
    },
    lev_validation_form: {
      title: 'Organization to Validate',
      fields: {
        organization_name: 'Organization Name',
        acronym: 'Acronym (optional)',
        other_name: 'Other Name (optional)',
        industry: 'Industry',
        location_empty:
          'Fill in if the company is registered/incorporated in a single jurisdiction, or if you want to optimize your search results.',
      },
      error: {
        industry_must_include_alpha: 'The industry must include at least one alphabetic character.',
      },
      user_suggestions:
        'One or more organizations with this name already exists. Click on one of the names below to update their report.',
      spelling_fix:
        'The following similar Organization Name is found online. Click on it if you prefer to use it instead of the name you entered.',
    },
    validation_form: {
      spelling_fix:
        'The following similar name is found online. Click on it if you prefer to use it instead of the name you entered.',
      last_validated_on: 'Last updated on ',
      nothing_found: 'Nothing found',
      show_more_tweets: 'Show {{count}} more results',
      submit_and_new: 'Submit and new',
      submit_more: 'Submit more',
      submit_all_new: 'Submit All as New',
      submit_as_new: 'Submit as New',
      submit_and_close: 'Submit validation',
      next: 'Next',
      cancel: 'Cancel',
      previous: 'Previous',
      privacy_PRIVATE: 'Private',
      privacy_PUBLIC: 'Shared',
      dont_include_twitter: `Don't include twitter`,
      year_of_birth: 'Year of Birth (optional)',
      edit_twitter: {
        title: 'Are you sure you want to change the twitter username?',
        description:
          'Changing the username will delete all tweets flagged from the other account.',
      },
      title: 'Individual to Validate',
      description_editing: '',
      user_suggestions:
        'One or more individuals with this name already exists. Click on one of the name below to update their report.',
      add_companies:
        'Organizations the Individual is affiliated with (up to 3) ',
      twitter_username: 'Twitter username',
      add_twitter_username:
        'Include a Twitter username to run a Twitter analysis (optional)',
      search_twitter_user: 'None of the above? Enter a Twitter username',
      select_twitter_user:
        'We found the following Twitter usernames that could belong to this individual. Select one to include Twitter in your report.',
      add_companies_editing:
        'Add or remove Companies (up to 3) to modify the results',
      positions_occupied:
        'Here are the Organizations and the Titles for each that this person occupied',
      helper_text_company: 'Press enter to add another Organization',
      helper_text_role: 'Press enter to add another Organization & role',
      no_results:
        'Run your first validation by clicking on the button on the top left',
      no_results_mobile:
        'No Validations ! Run your first validation by clicking the button on the bottom.',
      tooltip:
        'Current annual subscription. Totals may include multiple validations of the same individual and archived validations.',
      filters: {
        max_date_error: 'Must be before end date',
        min_date_error: 'Must be after start date',
      },
      alternative_first_name_note_main: 'Alternative First Name',
      alternative_first_name_note:
        ' provides limited results. Submit it in a separate Validation as a First Name if you want to extend the search on that name.',
      other_name_note_main: 'Other Name',
      other_name_note:
        ' provides limited results. Submit it in a separate Validation as an Organization name if you want to extend the search on that name.',
    },
    individual_search: {
      search_by_city: 'Search Individuals by City',
    },
    validation_privacy: {
      public_info:
        'This validation will be accessible to everyone in your team',
      private_info_MEMBER:
        'This validation will be accessible to yourself, your team admin(s), the account admin(s) and the account owner',
      private_info_LEAD:
        'This validation will be accessible to yourself, the account admin(s) and the account owner',
      private_info_ADMIN:
        'This validation will be accessible to yourself and the account owner',
      private_info_OWNER: 'This validation will only be accessible to yourself',
    },
    csv_validation_usage: {
      validations_remaining:
        'You have {{value}} validations remaining through CSV for today.',
      zero_validations_remaining:
        'You have no validation remaining through CSV for today. Please submit your validations on a individual basis.',
      limit_exceeded:
        'You have exceeded your CSV limit. You must remove {{value}} validations before submitting.',
    },
  },
  labels: {
    labelsFindCreate: 'Select or create label',
    labelsConfirmDelete:
      'Are you sure you want to delete the label "{{name}}" ?',
    createLabel: 'Create new Label',
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    more: 'More',
    save: 'Save',
    tip: 'Use labels to organize and easily track validations by project.',
    labelAdd: 'Add label',
  },
  pdf: {
    settings: {
      preferences: 'Preferences',
      group_by: 'Group by',
      risk: 'Risk',
      event: 'Event',
      display_options: 'Options',
      show_pep_soe: 'PEP/SOE',
      show_notes: 'Notes',
      show_reviewer: 'Reviewer',
      show_article_summary: 'Article Summary',
      show_validation_labels: 'Validation Labels',
      show_snippet: 'Article Snippet',
      show_executive_summary: 'Executive Summary',
    },
    header: {
      report_title: 'Online Media Report',
      powered_by: 'powered by',
    },
    footer: {
      report_generated_by: 'Report generated by',
      on: 'on',
      page: 'Page',
    },
    article: {
      id_match: 'ID Match',
      no_title_available: 'No title available',
      no_note_content: 'No note content',
      unknown_user: 'Unknown',
      user_label: 'User',
      note_at: ' at ',
    },
  },
  report: {
    download_with_count: 'Download {{count}} link',
    download_with_count_plural: 'Download {{count}} links',
    download_with_filters: 'Download PDF ({{count}} filter applied)',
    download_with_filters_plural: 'Download PDF ({{count}} filters applied)',
  },
  popup: {
    messages: {
      validationProcessing: 'Your validation is being processed',
      liveUpdateActivated: 'LiveUpdate alerts activated',
      liveUpdateDeactivated: 'LiveUpdate alerts deactivated',
      liveUpdateUnavailable: 'LiveUpdate alerts unavailable in your plan',
      liveUpdateLimitReached:
        'LiveUpdate limit reached. Contact us or disable an activated LiveUpdate.',
      validationUpdating: 'Your validation is being updated',
      accountRestricted:
        'Account restricted to view reports. Contact us to validate entities.',
      validationLimitReached:
        'Validation limit reached. Contact us to upgrade your plan.',
      subscriptionExpired:
        'Your subscription has expired. Contact Valital or your account administrator.',
      subscriptionExpiredNotAdmin:
        'Your subscription has expired. Contact your company administrator.',
      subscriptionExpiredAdmin:
        'Your subscription has expired. Contact Valital.',
      teamValidationsExhausted:
        'All team validations have been used. You can reallocate validations in the User Management.',
      validationArchived: 'Validation has been archived',
      validationUnarchived: 'Validation has been unarchived',
      validationDeleted: 'Validation has been deleted',
      userInvited: '{{userName}} has been invited to join Valital',
      validationPrivate: 'Validation is private.',
      validationShared: 'Validation is shared with your team',
      validationReviewed: 'Validation has been reviewed',
    },
  },
};
